import React from "react";
import { Field, UseFieldConfig } from "react-final-form";
import FormSlider, { FormSliderProps } from "ui/Form/Slider";

type Props = FormSliderProps & UseFieldConfig<unknown[]>;

const SliderField: React.FC<Props> = ({
    labelProps,
    fieldGroupProps,
    fieldControlProps,
    inputProps,
    ...fieldProps
}) => {
    return (
        <Field name={inputProps.name} {...fieldProps}>
            {({ input, meta }) => {
                const { disabled, ...restInputProps } = inputProps;

                return (
                    <FormSlider
                        error={!!(meta.error || meta.submitError)}
                        errorMessage={meta.submitError}
                        labelProps={labelProps}
                        fieldGroupProps={fieldGroupProps}
                        fieldControlProps={fieldControlProps}
                        inputProps={{
                            ...input,
                            ...restInputProps,
                            value: input.value === "" ? inputProps.max : input.value,
                            disabled,
                        }}
                    />
                );
            }}
        </Field>
    );
};

export default SliderField;
